/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { AppSettingTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const appSettingResetTimestamp = state => ({
  ...state,
  timestamp: Date.now()
});

export const appSettingFetchAppSettingSuccess = (state, { appSettingData }) => ({
  ...state,
  appSettingData
});

export const appSettingSetLoading = (state, { appSettingIsLoading }) => ({
  ...state,
  appSettingIsLoading
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [AppSettingTypes.APP_SETTING_FETCH_APP_SETTING_SUCCESS]: appSettingFetchAppSettingSuccess,
  [AppSettingTypes.APP_SETTING_SET_LOADING]: appSettingSetLoading
});
